// Styles
import Loader from "../Loader/Loader";
import styles from "./FullScreenLoader.module.scss";

const FullScreenLoader = () => {
  return (
    <div className={styles.root}>
      <div className={styles.loaderContainer}>
        <Loader />
      </div>
    </div>
  );
};

export default FullScreenLoader;
